import {
  apiURL
} from '../../config/app';

const getSchedule = async ({ authToken, date, startDate, endDate }) => {
  let query = ''
  if(date) {
    query += `date=${date}&`
  } else if (startDate && endDate) {
    query += `startDate=${startDate}&endDate=${endDate}&`
  }
  const response = await fetch(`${apiURL}/appointments${query ? `?${query}` : ''}`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    }
  })
  if (!response.ok)
    throw await response.json()

  return response.json();
};

const newSchedule = async ({ payload, authToken }) => {
  const response = await fetch(`${apiURL}/appointments`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    body: JSON.stringify(payload)
  })
  if (!response.ok)
    throw await response.json()
  
  return response.json();
};

const getDoctors = async ({ authToken }) => {
  const response = await fetch(`${apiURL}/users/doctors`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    }
  })
  if (!response.ok)
    throw await response.json()
  
  return response.json();
};

const updateAppointments = async ({ payload, authToken }) => {
  const response = await fetch(`${apiURL}/appointments/${payload.id}`, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    body: JSON.stringify(payload)
  })
  if (!response.ok)
    throw await response.json()

  return response.json();
};

const deleteAppointments = async ({ payload, authToken }) => {
  const response = await fetch(`${apiURL}/appointments/${payload.id}`, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    body: JSON.stringify(payload)
  })
  if (!response.ok)
    throw await response.json()
  
  return response.json();
};

export default {
  newSchedule,
  getSchedule,
  getDoctors,
  updateAppointments,
  deleteAppointments
};



// WEBPACK FOOTER //
// ./api/schedule.js